import { render } from "./ViewBackground.vue?vue&type=template&id=5d7a7e28"
import script from "./ViewBackground.vue?vue&type=script&lang=js"
export * from "./ViewBackground.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__